import React from 'react';

interface SliderDotProps {}

export const SliderDot: React.FC<SliderDotProps> = () => {
  return (
    <div
      style={{
        width: '20px',
        height: '20px',
        outline: '1px solid',
        borderRadius: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <span
        className='selected-dot'
        style={{
          width: '8px',
          height: '8px',

          borderRadius: '100%',
          background: 'black',
        }}
      />
    </div>
  );
};
